import { PortalBPSubMenuList } from '../list';

export class StakeholdersView extends PortalBPSubMenuList {
  name = 'stakeholders-view';
}